module.exports = __webpack_public_path__ + "static/media/Galdisa_PumpkinSeedsKernels.b4384032.pdf";